<p *ngIf="isBeta" [innerHTML]="message" class="alert alert-warning"></p>
